import React, { useState, useEffect } from "react";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.css";
import Footer from "src/components/footer";
import TeamCard from "./components/Hovercard";
import { fetchTeamMembers, TeamData } from "src/services/teamService";
import { Link } from "react-router-dom";
import { scrollToTop } from "src/shared/utils/appConstant";
import { pageRoutes } from "src/shared/utils/pageRoutes.constant";
const Team = () => {
  const [teamData, setTeamData] = useState<TeamData>({});
  const [loading, setLoading] = useState(true);
  const [openSections, setOpenSections] = useState<{[key: string]: boolean}>({});

  useEffect(() => {
    const loadTeamMembers = async () => {
      try {
        const data = await fetchTeamMembers();
        setTeamData(data);
        // Open first section by default
        const categories = Object.keys(data);
        if (categories.length > 0) {
          setOpenSections({ [categories[0]]: true });
        }
      } catch (error) {
        console.error('Failed to load team members:', error);
      } finally {
        setLoading(false);
      }
    };

    loadTeamMembers();
  }, []);

  const toggleSection = (category: string) => {
    setOpenSections(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };
  return (
    <div className="team-container">
      <div className="team-image-container image-container position-rel">
        <div className="text-container">
          <h1 className="heading drop-in">Our Team</h1>
          <p className="heading-desc display-block display-none drop-in-2">
            At Wingman Partners, we're more than just a business; we're a team
            of passionate individuals who believe in the power of dreams and innovation.
            We're here to be your trusted partner in your journey to success.
          </p>
        </div>
        <div className="breadcrumb position-abs drop-in-2">
          <Link to={pageRoutes.Home} onClick={scrollToTop} >Home</Link>
          <span className="breadcrumb-separator"> / </span>
          <p className="fw-light">
            <Link to={pageRoutes.Team}>Our Team</Link>
          </p>
        </div>
        <div className="red-bg-box"></div>
      </div>
      <div className="meet-our-team">
        <div className="team-header">
          <h2>Meet Our Team</h2>
        </div>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden"></span>
            </div>
          </div>
        ) : (
          Object.entries(teamData).map(([category, members]) => (
            <div key={category} className="team-category">
              <div 
                className="category-header" 
                onClick={() => toggleSection(category)}
              >
                <h3>{category}</h3>
                <span className={`toggle-icon ${openSections[category] ? 'open' : ''}`}>
                  ▼
                </span>
              </div>
              {openSections[category] && (
                <div className="card-main-container">
                  {Array.isArray(members) && members
                    .sort((a, b) => a.rank - b.rank)
                    .map((member, index) => (
                    <div className="team-cards drop-in-3" key={member.id}>
                      <TeamCard
                        index={index}
                        frontImage={member.url || ""}
                        backImage={""}
                      />
                      <div className="team-card-content">
                        <p className="team-card-name">{`${member.first_name} ${member.last_name}`}</p>
                        <p className="team-card-desg">{member.designation}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Team;
